var map = {
	"./chdbits.png": "3893",
	"./hdchina.png": "6e14",
	"./hdhome.png": "5918",
	"./keepfrds.png": "6376",
	"./m-team.png": "6e33",
	"./springsunday.png": "83eb",
	"./u2.png": "194e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c9e";